/* global MicroModal */

export default class TeamList {
  constructor(element) {
    this.photo = '';
    this.name = '';
    this.title = '';
    this.bio = '';

    this.twitter = '';
    this.linkedIn = '';
    this.facebook = '';

    this.list = element;
    this.modalId = 'team-member-modal';

    this.bindEvents();
    this.renderModalTemplate();
    this.showInitialMember();
  }

  bindEvents() {
    this.onListClick = this.onListClick.bind(this);
    this.onListMouseover = this.onListMouseover.bind(this);
    this.list.addEventListener('click', this.onListClick);
    this.list.addEventListener('mouseover', this.ListMouseover);
  }

  /**
   * Render template and place at end of body
   */
  renderModalTemplate() {
    const template = `<div class="modal modal--slide" id="${this.modalId}" aria-hidden="true">
        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
            <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="team-member-title">
                <button class="modal__close" aria-label="Close modal" data-micromodal-close></button>

                <div class="modal__content" id="team-member-content"></div>
            </div>
        </div>
    </div>`;

    document.body.insertAdjacentHTML('beforeend', template);

    // Save reference for scroll positioning later
    this.modal = document.getElementById(this.modalId);
    this.overlay = this.modal.querySelector('.modal__overlay');
    this.modalContent = document.getElementById('team-member-content');
  }

  onListClick(event) {
    // If the event target doesn't match bail
    const $member = this.getMemberElement(event.target);
    if (!$member) return;

    event.preventDefault();
    history.replaceState({}, '', $member.href);

    this.loadData($member);
    this.showModal();
  }

  onListMouseover(event) {
    const $member = this.getMemberElement(event.target);
    this.loadData($member);
  }

  getMemberElement($element) {
    return $element.closest('.team-list__link');
  }

  showInitialMember() {
    const searchParams = new URLSearchParams(window.location.search);
    const memberName = searchParams.get('member');
    const $member = document.querySelector(`[data-slug="${memberName}"]`);
    if (!memberName || !$member) return;

    this.loadData($member);
    this.showModal();
  }

  loadData($member) {
    if (!$member) return;

    this.photo = $member.dataset.photo;
    this.name = $member.dataset.name;
    this.title = $member.dataset.title;
    if ($member.dataset.bio) {
      this.bio = $member.dataset.bio;
    }

    this.twitter = $member.dataset.twitter;
    this.linkedIn = $member.dataset.linkedin;
    this.facebook = $member.dataset.facebook;

    this.render();
  }

  unloadData() {
    this.photo = '';
    this.name = '';
    this.title = '';
    this.bio = '';

    this.twitter = '';
    this.linkedIn = '';
    this.facebook = '';

    this.modalContent.innerHTML = '';
  }

  showModal() {
    MicroModal.show(this.modalId, {
      awaitCloseAnimation: true,
      disableScroll: true,
      onClose: () => {
        this.closeModal();
      },
      onShow: () => {
        this.overlay.scrollTop = 0;
      },
    });
  }

  closeModal() {
    this.unloadData();
    // reset url
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete('member');
    const url = `${location.pathname}${searchParams.toString()}`;
    history.replaceState({}, '', url);
  }

  render() {
    let template = `
      <img class="modal__team-image" src="${this.photo}">
      <div class="modal__text">
        <h3 class="type-headline-s">${this.name}</h3>
        <p class="team-member__title type-subhead-s mb-space-fixed-2">${this.title}</p>
    `;

    if (this.bio) {
      template += `<div class="text type-body mb-space-fixed-2">
        ${this.bio}
      </div>`;
    }

    if (this.twitter || this.facebook || this.linkedIn) {
      template += '<div class="team-member__social">';

      if (this.twitter) {
        template += `<a class="team-member__social-link" href="https://twitter.com/${this.twitter}" title="Twitter" target="_blank" rel="noopener noreferrer">
            <svg width="46" height="45" viewBox="0 0 46 45" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.4661 40.7826C31.8246 40.7826 41.319 26.7138 41.319 14.5134C41.319 14.1138 41.319 13.716 41.2914 13.32C43.1385 12.013 44.7329 10.3947 46 8.54095C44.2777 9.28796 42.4504 9.77762 40.5794 9.99355C42.5496 8.83985 44.0242 7.02502 44.7286 4.88695C42.876 5.96247 40.8492 6.72038 38.7357 7.12795C37.3127 5.64779 35.4308 4.66766 33.381 4.33924C31.3313 4.01082 29.2281 4.35242 27.3968 5.31118C25.5655 6.26994 24.1083 7.7924 23.2506 9.64298C22.3929 11.4936 22.1826 13.5691 22.6522 15.5484C18.9 15.3642 15.2294 14.4103 11.8785 12.7485C8.52754 11.0866 5.5713 8.75407 3.2016 5.90215C1.99473 7.93464 1.62509 10.3407 2.16794 12.6304C2.71079 14.9202 4.12532 16.9214 6.12352 18.2268C4.62153 18.1837 3.15224 17.7873 1.84 17.0712V17.1882C1.8406 19.3197 2.59488 21.3855 3.97492 23.0351C5.35496 24.6847 7.27578 25.8165 9.4116 26.2386C8.02217 26.6093 6.56434 26.6635 5.15016 26.397C5.75348 28.2313 6.92765 29.8354 8.50854 30.985C10.0894 32.1345 11.998 32.7721 13.9674 32.8086C12.0107 34.3132 9.76985 35.4257 7.37318 36.0823C4.9765 36.7389 2.47099 36.9269 0 36.6354C4.31601 39.3448 9.33785 40.7819 14.4661 40.7754" fill="currentColor"/>
            </svg>
          </a>`;
      }

      if (this.linkedIn) {
        template += `<a class="team-member__social-link" href="https://linkedin.com/in/${this.linkedIn}" title="LinkedIn" target="_blank" rel="noopener noreferrer">
            <svg width="46" height="45" viewBox="0 0 46 45" xmlns="http://www.w3.org/2000/svg">
              <path d="M42.6043 0H3.3957C2.4951 0 1.63139 0.349983 0.994577 0.972955C0.35776 1.59593 0 2.44086 0 3.32188V41.6781C0 42.5591 0.35776 43.4041 0.994577 44.0271C1.63139 44.65 2.4951 45 3.3957 45H42.6043C43.5049 45 44.3686 44.65 45.0054 44.0271C45.6422 43.4041 46 42.5591 46 41.6781V3.32188C46 2.44086 45.6422 1.59593 45.0054 0.972955C44.3686 0.349983 43.5049 0 42.6043 0ZM13.7106 38.3344H6.79459V16.8438H13.7106V38.3344ZM10.2478 13.8656C9.46328 13.8613 8.69767 13.6297 8.04757 13.2002C7.39748 12.7706 6.89203 12.1622 6.59502 11.4519C6.298 10.7416 6.22274 9.96111 6.37873 9.20898C6.53471 8.45685 6.91495 7.76677 7.47146 7.22584C8.02798 6.68491 8.73581 6.31738 9.50565 6.16961C10.2755 6.02185 11.0728 6.10049 11.797 6.3956C12.5212 6.69071 13.1398 7.18906 13.5747 7.82777C14.0097 8.46648 14.2415 9.21692 14.2408 9.98438C14.2482 10.4982 14.1498 11.0082 13.9514 11.484C13.7531 11.9598 13.4588 12.3917 13.0862 12.7539C12.7136 13.1161 12.2702 13.4012 11.7826 13.5922C11.2949 13.7832 10.773 13.8762 10.2478 13.8656ZM39.2022 38.3531H32.2895V26.6125C32.2895 23.15 30.7849 22.0813 28.8426 22.0813C26.7918 22.0813 24.7793 23.5938 24.7793 26.7V38.3531H17.8633V16.8594H24.5142V19.8375H24.6036C25.2713 18.5156 27.6096 16.2563 31.1778 16.2563C35.0367 16.2563 39.2054 18.4969 39.2054 25.0594L39.2022 38.3531Z" fill="currentColor"/>
            </svg>
          </a>`;
      }

      if (this.facebook) {
        template += `<a class="team-member__social-link" href="https://facebook.com/${this.facebook}" title="Facebook" target="_blank" rel="noopener noreferrer">
            <svg width="46" height="45" viewBox="0 0 46 45" xmlns="http://www.w3.org/2000/svg">
              <path d="M46 22.5C46 10.0736 35.7026 0 23 0C10.2974 0 0 10.0736 0 22.5C0 33.7302 8.41072 43.0387 19.4062 44.7267V29.0039H13.5664V22.5H19.4062V17.543C19.4062 11.9039 22.8401 8.78906 28.0937 8.78906C30.6093 8.78906 33.2422 9.22852 33.2422 9.22852V14.7656H30.342C27.485 14.7656 26.5937 16.5001 26.5937 18.2812V22.5H32.9727L31.9529 29.0039H26.5937V44.7267C37.5893 43.0387 46 33.7302 46 22.5Z" fill="currentColor"/>
            </svg>
          </a>`;
      }
      template += '</div>';
    }

    template += '</div>';

    this.modalContent.innerHTML = template;
  }

  unmount() {
    this.list.removeEventListener('click', this.onListClick);
    this.list.removeEventListener('mouseover', this.ListMouseover);
  }
}
